<template lang="pug">
div
  v-card.elevation-0(v-if='verifyState === "waiting"')
    v-toolbar.elevation-0(color='white')
      v-toolbar-title Account activeren

    .pa-2
      v-card-text.pb-0
        v-form
          text-field(
            placeholder='Nieuw wachtwoord',
            type='password',
            v-model='password',
            @keyup.enter='verify',
            :append-icon="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
            @click:append='passwordVisible = !passwordVisible',
            :type="passwordVisible ? 'text' : 'password'",
            :error-messages='passwordValidationErrors',
            @change='$v.password.$touch()',
            @blur='$v.password.$touch()'
            )
      v-card-actions.pa-4
        v-spacer
        v-btn(color='primary', @click='verify', :loading='loading', :disabled='$v.$invalid') Activeren

  v-card.elevation-0(v-else-if='verifyState === "success"')
    v-toolbar.elevation-0(color='white')
      v-toolbar-title Account geactiveerd

    v-card-text
      p Je account is geactiveerd. Je kan dit venster sluiten of doorgaan naar de
        =" "
        router-link(:to='{ name: "login" }') login

  v-card.elevation-0(v-else-if='verifyState === "failed"')
    v-toolbar.elevation-0
      v-toolbar-title Fout
    v-card-text
      p Er is iets fout gegaan. Probeer het nog een keer en als dat niet lukt, neem dan
        =" "
        router-link(:to='{ name: "contact" }') contact
        =" "
        | met ons op

  v-card.elevation-0(v-else-if='verifyState === "expired"')
    v-toolbar.elevation-0
      v-toolbar-title Link verlopen

    v-card-text
      p Je account activatie email is verlopen. Vul je email adres in en met onderstaande knop kan je dan een nieuwe aanvragen.
      p Klik dan op de link in de nieuwe email.
      text-field(prepend-icon='fa fa-user', label='Email', type='text', v-model='emailResendVerification', @keyup.enter='resendVerificationMail')
    v-card-actions.pa-4
      v-spacer
      v-btn(color='primary', @click='resendVerificationMail', :loading='loading') Opnieuw versturen

</template>

<script>
import { isTokenExpiredOrInvalid } from '@/store/modules/auth'
import { regex } from 'vuelidate/lib/validators/common'
import { required } from 'vuelidate/lib/validators'
import { strongPasswordRegex } from '@/helpers/auth'

export default {
  data () {
    return {
      password: null,
      emailResendVerification: null,
      loading: false,
      verifyState: 'waiting',

      passwordVisible: false
    }
  },

  computed: {
    passwordValidationErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Dit veld is verplicht')
      !this.$v.password.strongPassword && errors.push('Wachtwoord moet minimaal 1 kleine letter, 1 hoofdletter, 1 cijfer en 1 speciaal teken bevatten met minimale lengte van 8 tekens.')
      return errors
    }
  },

  methods: {
    async verify () {
      this.loading = true

      try {
        await this.$store.dispatch('auth/verifyAccount', {
          token: this.$route.query.token,
          password: this.password
        })

        this.verifyState = 'success'
      } catch (error) {
        console.error(error)

        if (error.response.status === 401) {
          this.verifyState = 'expired'
        } else {
          this.verifyState = 'failed'
        }
      }

      this.loading = false
    },

    async resendVerificationMail () {
      this.loading = true

      try {
        await this.$store.dispatch('auth/resendVerification', {
          email: this.emailResendVerification
        })

        this.$router.push({
          name: 'login'
        })
      } catch (error) {
        console.error(error)

        this.$root.$snackbar.show('Er is iets fout gegaan. Probeer het nog een keer.')
      }

      this.loading = false
    }
  },

  created () {
    if (isTokenExpiredOrInvalid(this.$route.query.token)) {
      this.verifyState = 'expired'
    }

    if (!this.$route.query.token) {
      this.$router.push({
        name: 'login'
      })
    }
  },

  validations: {
    password: {
      required,
      strongPassword: regex('strongPassword', strongPasswordRegex)
    }
  }
}
</script>
